import type { NextPage, GetStaticProps } from 'next'

import Link from 'next/link'
import SEO from '../../modules/seo'
import Page from '../../components/pages/about/System'


export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
    },
    revalidate: 86400,
  }
}

interface IProps {

}

const Component: NextPage<IProps> = (props) => {
  const pageTitle = "환경영향평가 제도안내"
  const pageDescription = "환경영향평가는 환경영향평가 대상사업의 사업계획을 수립하려고 할 때 그 사업의 시행이 환경에 미치는 영향을 미리 조사·예측·평가하여 해로운 환경영향을 피하거나 줄이는 방안을 마련하는 제도입니다. 이는 각종 개발사업의 시행으로 인한 환경파괴와 환경오염을 사전에 방지하기 위한 정책 수단으로 활용되며, 환경적으로 건전하고 지속가능한 개발을 유도하여 쾌적한 환경을 유지·조성하는 데 목적을 두고 있습니다."

  return (
    <>
      <SEO title={pageTitle} description={pageDescription} />
      <Page {...props} />
    </>
  )
}

export default Component
